import React from 'react';
import { modules, promises } from '../data/modules';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function SystemSection() {
  return <section className="bg-white px-4 py-4" data-id="element-135" data-mp="3gg5aviwskaka">
      <div className="mx-auto max-w-4xl" data-id="element-136" data-mp="3bhu0n72l3y1j">
        <div className="mb-2.5 text-center" data-id="element-137" data-mp="3bkzlub83efrz">
          <p className="mb-0.5 font-head text-[11px] font-bold uppercase tracking-[0.18em] text-golf-gold sm:text-sm" data-id="element-138" data-mp="36kld0qyo31sw">
            The Complete System You've Been Looking For
          </p>
          <h2 className="mb-1.5 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-139" data-mp="2wtgz7ukq9mzn">
            One Complete 6-in-1 Golf Coaching System
          </h2>
          <div className="mb-1.5 inline-block rounded-md border border-golf-gold/70 bg-golf-green px-3 py-1.5 shadow-md" data-id="element-140" data-mp="2ntkj4hcelwg7">
            <p className="font-display text-lg font-extrabold uppercase leading-none tracking-tight text-white sm:text-2xl" data-id="element-141" data-mp="2it68crjf48eh">
              GOLF COACH PRO™
            </p>
            <p className="font-head text-[11px] font-semibold text-golf-lime sm:text-sm" data-id="element-142" data-mp="13zhr170q7c0d">
              The Complete Ready-to-Use System for Professional Golf Coaches
            </p>
          </div>
          <div className="mx-auto max-w-3xl space-y-0.5 text-[13px] font-medium leading-snug text-golf-muted sm:text-base" data-id="element-143" data-mp="u1ab8ri6azzy">
            <p data-id="element-144" data-mp="yzbwnj32nbel">Not another basic golf course.</p>
            <p data-id="element-145" data-mp="yy0shi5ps1my">Not another random collection of drills.</p>
            <p data-id="element-146" data-mp="1mqr1pjm8g6tj">
              A practical system created for experienced coaches who want ready-to-use professional
              resources without spending hours preparing them.
            </p>
          </div>
          <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[11px] font-semibold text-golf-green sm:text-sm" data-id="element-147" data-mp="1cqqgfs4szgmp">
            {promises.map(promise => <li key={promise} data-id="element-148" data-mp="1bbl0ss8swtp">✔ {promise}</li>)}
          </ul>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-149" data-mp="6cipoiz39fw5">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-2.5 rounded-lg border border-golf-line bg-golf-light p-3 shadow-sm transition-colors duration-150 ease-out hover:border-golf-lime" data-id="element-150" data-mp="28yea1cp1b9tv">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-golf-green font-display text-lg font-extrabold leading-none text-golf-lime transition-colors duration-150 ease-out group-hover:bg-golf-deep" data-id="element-151" data-mp="1u98djwhkzxpo">
                {module.num}
              </span>
              <div data-id="element-152" data-mp="1lamvs3jxompy">
                <h3 className="font-head text-[14px] font-bold leading-tight text-golf-green sm:text-lg" data-id="element-153" data-mp="1g97d2i58asaq">
                  ✅ {module.title}
                </h3>
                <p className="mt-0.5 text-xs font-medium leading-snug text-golf-muted sm:text-sm" data-id="element-154" data-mp="1bc77078dppjm">
                  {module.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-2.5 text-center" data-id="element-155" data-mp="35mkmgls776ip">
          <a href={OFFER_ANCHOR} className="inline-block" aria-label="Go to the purchase section" data-id="element-156" data-mp="3d8ocdvglk5vw">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[220px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-157" data-mp="3i5y1fa02qfj7" />
          </a>
        </div>
      </div>
    </section>;
}